import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BehaviorSubject } from 'rxjs';

import { routes } from './app.routes';
import { environment } from 'src/environments/environment';
import { appinfo } from './appinfo';

import {
  GeaMesCognitoModule,
  GeaMesCognitoAuthService,
  GeaMesAuthInterceptor,
  COGNITO_CONFIG,
  APPLICATION_NAME,
  ALLOW_SCREENAUTH,
  APIGATEWAY_CONFIG
} from '@gea-mes/cognito';

import {
  GEA_MES_NAVBAR_COGNITO_CONFIG,
  GEA_MES_NAVBAR_APPLICATION_NAME,
  GEA_MES_NAVBAR_COGNITO_AUTH_SERVICE,
  GEA_MES_NAVBAR_MENU_SERVICE,
  GEA_MES_NAVBAR_ENV_PROD_STATUS,
  GEA_ENVIROMENT,
  NavItem,
  GEA_MES_NAVBAR_APP_ID_FOR_WHATSNEW_TEXT
} from '@gea-mes/navbar';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),

    importProvidersFrom(GeaMesCognitoModule),

    { provide: COGNITO_CONFIG, useValue: environment.cognitoOptions },
    { provide: HTTP_INTERCEPTORS, useClass: GeaMesAuthInterceptor, multi: true },
    { provide: GEA_MES_NAVBAR_APPLICATION_NAME, useValue: 'Attendance Configuration' },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },
    { provide: GEA_MES_NAVBAR_COGNITO_CONFIG, useValue: environment.cognitoOptions },
    { provide: GEA_MES_NAVBAR_COGNITO_AUTH_SERVICE, useClass: GeaMesCognitoAuthService },
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) },
    { provide: GEA_MES_NAVBAR_APP_ID_FOR_WHATSNEW_TEXT, useValue: 'AttendanceConfig' }
  ]
};
